<div class="rangebox">
    <button data-target="#collapse501" data-toggle="collapse" class="collapsebtn"
        type="button">Price ( {{ currency }} )</button>
        <a *ngIf="flightsCopy.length" style="cursor: pointer;font-size: 12px;" class="float-right" (click)="clearPriceFilter()">Clear</a>
    <div *ngIf="flightsCopy.length" id="collapse501" class="collapse show" style="clear: both;">
        <div class="price_slider1">
            <span *ngIf="flightsCopy.length" class="lable-slider">
                <ngx-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options"
                (valueChange)="valueChange($event)"
                (highValueChange)="highValueChange($event)"></ngx-slider>
            </span>
        </div>
    </div>
</div>